type ConfidenceIndicatorProps = {
  value: number;
};

export function ConfidenceIndicator({ value }: ConfidenceIndicatorProps) {
  const safe = Math.max(0, Math.min(1, value));
  const percent = Math.round(safe * 100);

  return (
    <div className="ui-confidence">
      <div className="ui-confidence-bar">
        <div className="ui-confidence-fill" style={{ width: `${percent}%` }} />
      </div>
      <div className="ui-confidence-copy">
        <span>Execution confidence</span>
        <strong>{percent}%</strong>
      </div>
    </div>
  );
}
